export default "__VITE_ASSET__DiMpG0Bf__"